import React, { useMemo } from "react";
import { isStartListStatus, isLiveStatus } from "helpers/status";
import MirsTable from "components/general/table/Table";
import CaptionTable from "components/general/table/CaptionTable";
//General
import { getIsRoadRace } from 'components/sports/crd/helper/CrdHelpers'
import Status from "components/presentation/Status";

import { useViewport } from 'components/general/useViewPort'
import Label from "components/general/Label"

//Race Info
import CrdRaceInfo from 'components/sports/crd/views/CrdRaceInfo'
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

//Road Race
import { TableColumns as ColumnsRoadRaceStart, TableColumnsSM as ColumnsRoadRaceStartSM } from 'components/sports/crd/events/road_race/start/Columns'
import { TableColumns as ColumnsRoadRaceAnalysis, TableColumnsSM as ColumnsRoadRaceAnalysisSM } from 'components/sports/crd/events/road_race/analysis/ColumnsAnalysis'
//Time Trial
import { TableColumns as ColumnsTimeTrialStart, TableColumnsSM as ColumnsTimeTrialStartSM } from 'components/sports/crd/events/time_trial/start/Columns'
import { TableColumns as ColumnsTimeTrialAnalysis, TableColumnsSM as ColumnsTimeTrialAnalysisSM } from 'components/sports/crd/events/time_trial/analysis/ColumnsAnalysis'

import { findArray } from 'helpers/utils'
import NotAvailable from "components/common/NotAvailable";

const getConfiguration = (data, rsc, resultStatus, breakPoint) => {

    //determinar si la configuacion viene del config o del result depende del deporte
    const columnsAdded = data?.config?.extendedConfig ? data.config.extendedConfig.sort((a, b) => a.pos - b.pos) : []
    const isStartList = isStartListStatus(resultStatus) ? true : false
    const isLive = isLiveStatus(resultStatus) ? true : false
    const isRoadRace = getIsRoadRace(rsc);
    let current = findArray(data?.results?.extendedInfos, { ei_code: ['AFTER_DIST'] })?.ei_value

    let configuration = {
        caption: null,
        columns: [],
        //subComponent: null,
        hiddenColumns: [],
        sortBy: [],
        configs: {
            isStartList: isStartList,
            columnsAdded: columnsAdded,
        }

    };


    configuration.caption = <CaptionTable
        leftCol={<>{<Label data="HeaderRaceAnalysis" />} {(breakPoint === "sm" || breakPoint === "xs") ? '-' + (current) : ''}</>}
        //centerCol={(breakPoint === "sm" || breakPoint === "xs") ? (current) : ''}
        rightCol={<Status typeToPrint='result' scheduleStatus={data?.results?.schedule?.status?.code} resultStatus={resultStatus} />}
    />

    configuration.sortBy = isStartList
        ? [{ id: 'Bib', desc: false }]
        : isLive
            //is live
            ? (isRoadRace)
                ? [{ id: 'RankIntermediate', desc: false }]
                : [{ id: 'Rank', desc: false }]
            //Finish
            : (isRoadRace)
                ? [{ id: 'RankIntermediate', desc: false }]
                : [{ id: 'Rank', desc: false }]


    if (isRoadRace) {
        configuration.columns = isStartList
            ? breakPoint === "sm" || breakPoint === "xs"
                ? ColumnsRoadRaceStartSM()
                : ColumnsRoadRaceStart()
            : isLive
                ? breakPoint === "sm" || breakPoint === "xs"
                    ? ColumnsRoadRaceAnalysisSM(columnsAdded)
                    : ColumnsRoadRaceAnalysis(columnsAdded)
                : breakPoint === "sm" || breakPoint === "xs"
                    ? ColumnsRoadRaceAnalysisSM(columnsAdded)
                    : ColumnsRoadRaceAnalysis(columnsAdded);
    } else {
        //Time Trial
        configuration.columns = isStartList
            ? breakPoint === "sm" || breakPoint === "xs"
                ? ColumnsTimeTrialStartSM()
                : ColumnsTimeTrialStart()
            : isLive
                ? breakPoint === "sm" || breakPoint === "xs"
                    ? ColumnsTimeTrialAnalysisSM(columnsAdded)
                    : ColumnsTimeTrialAnalysis(columnsAdded)
                : breakPoint === "sm" || breakPoint === "xs"
                    ? ColumnsTimeTrialAnalysisSM(columnsAdded)
                    : ColumnsTimeTrialAnalysis(columnsAdded);

    }

    return configuration;
};


const CrdAnalysis = ({ data }) => {
    const { mirs_rsc } = useUrlFriendlyToParameters()
    const { breakPoint } = useViewport();
    const resultStatus = data && data.results && data.results.status && data.results.status.code;
    //Cuando cambimos de estado de resultados forzamos a repintar la tabla con las nuevas columnas 
    //aunque no hay cambios    
    // eslint-disable-next-line
    const configEvent = useMemo(() => getConfiguration(data, mirs_rsc, resultStatus, breakPoint), [resultStatus, mirs_rsc, breakPoint]);
    const items = data?.results?.items
    const showAllExtendedResults = items?.some(item => item?.extendedResults?.some(item => item.er_code === 'INTERMEDIATE'));
    const showAllTeamAthletes = items?.teamathletes?.some(val => val.hasOwnProperty('athlete'));
    const showAll = showAllExtendedResults || showAllTeamAthletes;
    //Pasamos el id de la columna a ocultar definido en la configuracón de
    let hiddenColumns = []
    if (!showAll) hiddenColumns.push('Expander')
    return (
        <>
            {data?.results ? (
                <>
                    {data?.results?.items ? (
                        < MirsTable
                            className='table-result'
                            //Dato to show by row
                            data={data.results.items}
                            //Columnas a visualizar 
                            columns={configEvent.columns}
                            //pageSizeCustom={data.items.length} //ponerlo por defecto en el componente                             
                            //Key by row necesary in order to no paint innecesary
                            keyRow='participant-code'
                            //Component caption
                            caption={configEvent.caption}
                            //Columns to hidde 
                            hiddenColumns={hiddenColumns}
                            //When show tble is sorted by 
                            initialSortBy={configEvent.sortBy}
                            //Show buttons move to splits 
                            showNavExtendedData={false}
                            id={`mirs-table-race-analisys-${mirs_rsc}`}
                            hasRelatedTimeline={true}
                        />
                    ) : ('')
                    }

                </>
            ) : (
                <NotAvailable />
            )
            }
            {data?.config ? (
                <CrdRaceInfo config={data.config} />
            ) : ""}
        </>
    );
};

export default CrdAnalysis;
